const REASONS = ['idle', 'expired', 'ended', 'password'] as const
export type LogoutReason = (typeof REASONS)[number]

// sessionStorage so the notice belongs to the tab that was logged out; a new
// tab must not inherit it.
const KEY = 'logoutReason'

const REASON_BY_GATEWAY_MESSAGE = new Map<unknown, LogoutReason>([
  ['Session expired due to inactivity', 'idle'],
  ['Token expired', 'expired'],
  ['Session ended', 'ended'],
  ['Session ended by a password change', 'password'],
])

export const reasonForGatewayMessage = (gatewayMessage: unknown) =>
  REASON_BY_GATEWAY_MESSAGE.get(gatewayMessage)

export const rememberLogoutReason = (reason: LogoutReason | undefined) => {
  if (reason) sessionStorage.setItem(KEY, reason)
}

export const forgetLogoutReason = () => sessionStorage.removeItem(KEY)

export const takeLogoutReason = (): LogoutReason | null => {
  const stored = sessionStorage.getItem(KEY)
  forgetLogoutReason()
  return REASONS.find(reason => reason === stored) ?? null
}
